import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { SpinnerOverlayComponent } from '../spinner-overlay/spinner-overlay.component';

@Injectable({
    providedIn: 'root',
})
export class LoaderService {
    private overlayRef: OverlayRef = this.overlay.create({
        hasBackdrop: true,
        backdropClass: 'cdk-overlay-dark-backdrop-loader',
        positionStrategy: this.overlay
            .position()
            .global()
            .centerHorizontally()
            .centerVertically(),
    });
    private activeRequests: number = 0;
    private dataProcessing: boolean = false;

    constructor(
        private snackBar: MatSnackBar,
        private overlay: Overlay,
    ) {}

    public showLoader(): void {
        this.activeRequests++;
        this.updateLoaderVisibility();
    }

    public hideLoader(): void {
        this.activeRequests--;
        this.updateLoaderVisibility();
    }

    public startDataProcessing(): void {
        this.dataProcessing = true;
        this.updateLoaderVisibility();
    }

    public stopDataProcessing(): void {
        this.dataProcessing = false;
        this.updateLoaderVisibility();
    }

    private updateLoaderVisibility(): void {
        if (this.activeRequests > 0) {
            if (this.overlayRef && !this.overlayRef.hasAttached()) {
                const spinnerOverlayPortal = new ComponentPortal(
                    SpinnerOverlayComponent,
                );
                this.overlayRef.attach(spinnerOverlayPortal);
            }
        } else {
            if (this.overlayRef.hasAttached()) {
                this.overlayRef.detach();
            }
        }
    }

    public openSnackBar(message: string, type: string): void {
        let panelClass = 'custom-snackbar';
        switch (type) {
            case 'error':
                panelClass = 'snackbar-error';
                break;
            case 'success':
                panelClass = 'snackbar-success';
                break;
            default:
                break;
        }
        this.snackBar.open(message, 'Close', {
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: [panelClass],
            duration: 5000,
        });
    }
}
